import { useCallback } from 'react';

import { TeamsChat } from '@this+that/models';
import log from 'loglevel';

import { getTeamsChats } from '../../../services/microsoft.service';
import { useTeamsCommunicationsStore } from '../../../store';
import { useTeamsIntegrations } from '../../Integrations';

export const useFetchTeamsChats = () => {
  const { setLoading, saveTeamsChats } = useTeamsCommunicationsStore();
  const userTeamsIntegrations = useTeamsIntegrations();

  const handleFetchTeamsChats = useCallback(async () => {
    if (!userTeamsIntegrations?.length) {
      log.warn('No Teams integration found. Cannot fetch chats.');
      return;
    }

    setLoading(true);
    try {
      const chatPromises = userTeamsIntegrations.map(async (integration) => {
        const { homeAccountId } = integration;
        if (!homeAccountId) {
          return [];
        }

        try {
          const response = await getTeamsChats(homeAccountId);
          const chats: Partial<TeamsChat>[] = response?.message || [];
          return chats.map((chat) => ({ ...chat, homeAccountId }));
        } catch (error) {
          log.error(
            `Error fetching chats for account ${homeAccountId}:`,
            error,
          );
          return [];
        }
      });

      const allChats = (await Promise.all(chatPromises)).flat();

      saveTeamsChats(allChats);
    } catch (error) {
      log.error('Error fetching Teams chats:', error);
    } finally {
      setLoading(false);
    }
  }, [userTeamsIntegrations, saveTeamsChats, setLoading]);

  return {
    handleFetchTeamsChats,
  };
};
